import { notification } from "antd";
import axios, { AxiosError, AxiosInstance } from "axios";
import { ErrorMessageResponse, ErrorResponse } from "../request-response/error-response";
import { map } from 'rxjs/operators';
import {defer, Observable} from 'rxjs';
import { useNavigate } from "react-router-dom";

class AxiosService {

    private static instance: AxiosService | null = null;
    axiosInstance : AxiosInstance = axios.create({ });


    private constructor() {
        this.axiosInstance.interceptors.response.use(function (response) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            // Do something with response data
            return response;
        }, function (error:AxiosError) {
            const response = error.response;
            if (error.status === 419){
                return axios.get("/sanctum/csrf-cookie").then(function (csrfResponse) {
                    return axios(error.response!.config);
                });
            } else if (error.status === 401) {
                if (!window.location.href.endsWith("/") && !window.location.href.endsWith("/login")) {
                    window.location.href = "/login";
                }
                
            }
            let description : string|undefined = undefined;
            if (response && response.data) {
                const responseData = response.data as ErrorResponse;
                if (responseData.message) description = responseData.message;
                else {
                    const errors : string[] = [];
                    if (responseData.errors) {
                        responseData.errors.forEach(error => {
                            if (error.message as string) errors.push(error.message as string);
                            else if (error.message as string[]) (error.message as string[]).forEach(thisError => errors.push(thisError));
                        })
                    }
                    if (errors) description = errors.join('\n');
                }
            }
            if (response?.config.url === "/api/users/current") {
                return Promise.resolve({data:{}});
            }
            notification.error({message:error.message, description});
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            return Promise.reject(error);
        });
    }

    public static getInstance(): AxiosService {
        if (this.instance === null) {
            this.instance = new AxiosService();
        }
        return this.instance;
    }

    public get<T>(url: string, queryParams?: object): Observable<T>{
        return defer(()=> this.axiosInstance.get<T>(url, { params: queryParams }))
        .pipe(map(result => result.data));
    };

    public post<T>(url: string, body?: object, queryParams?: object): Observable<T> {
        return defer(()=> this.axiosInstance.post<T>(url, body, { params: queryParams }))
            .pipe(map(result => result.data));
    };
    
    public put<T>(url: string, body: object, queryParams?: object): Observable<T> {
        return defer(()=>this.axiosInstance.put<T>(url, body, { params: queryParams }))
            .pipe(map(result => result.data));
    };
    
    public patch<T>(url: string, body: object, queryParams?: object): Observable<T> {
        return defer(()=> this.axiosInstance.patch<T>(url, body, { params: queryParams }))
            .pipe(map(result => result.data));
    };
    
    public delete<T>(url: string): Observable<T> {
        return defer(() => (this.axiosInstance.delete(url)))
            .pipe(map(result => result.data)
        );
    };
    
}

export default AxiosService